import moment from "moment";

export const configFlux = {
  type: "bar", // Type de base pour le graphique mixte
plugins: {
    title: {
        display: true,
        text: "Flux et bolus",
        font: { size: 14 },
        padding: 20,
    },
    legend: {
        position: "bottom",
        labels: { font: { size: 14 } },
    },
    tooltip: {
        enabled: true,
        mode: "index",
        intersect: false,
        external: undefined, // Utilise le tooltip natif
        displayColors: true,
        callbacks: {
            title: function (context) {
                return context[0].label;
            },
            label: function (context) {
                const label = context.dataset.label || "";
                const value = context.parsed.y;

                if (label.includes("Bolus")) {
                    return value > 0 ? `${label.split(" ")[0]}: ${value} mg` : "";
                } else {
                    return value > 0 ? `${label.split(" ")[0]}: ${value} mg/h` : "";
                }
            },
        },
    },
    datalabels: {
        display: false,
    },
},
interaction: {
    mode: "index",
    intersect: false,
},
hover: {
    mode: "index",
    intersect: false,
},
responsive: true,
maintainAspectRatio: false,
scales: {
    x: {
        grid: {
            display: true,
            color: "rgba(238, 238, 238, 0.5)",
        },
        ticks: {
            font: {
                size: 10,
            },
        },
    },
    y: {
        title: {
            display: true,
            text: "FLUX (mg/h)",
            font: { size: 14, weight: "bold" },
        },
        position: "left",
        beginAtZero: true,
        max: 9,
        grid: {
            display: true,
            color: "rgba(238, 238, 238, 0.5)",
        },
        ticks: {
            stepSize: 1,
            font: {
                size: 10,
            },
        },
    },
    y1: {
        title: {
            display: true,
            text: "BOLUS (mg)",
            font: { size: 14, weight: "bold" },
        },
        position: "right",
        beginAtZero: true,
        max: 10,
        grid: {
            display: false,
        },
        ticks: {
            stepSize: 1,
            font: {
                size: 10,
            },
        // Couleur mauve pour l'axe des bolus
        color: "#7F7DE7",
      },
      // Couleur mauve pour l'axe Y des bolus
      border: {
        color: "#7F7DE7",
      },
    },
  },
};

export const dataConfigFlux = (data, isLecigimon) => {
  configFlux.plugins.title.text = isLecigimon
    ? `Flux (informations relevées le ${moment(data.date).format("DD/MM/YYYY")})`
    : `Flux et bolus (informations relevées le ${moment(data.date).format("DD/MM/YYYY")})`;

  // Masquer l'axe Y1 (bolus) pour LECIGIMON
  if (configFlux.scales.y1) {
    configFlux.scales.y1.display = !isLecigimon;
  }

  // Convertir les valeurs 0 en null pour les flux (pour ne pas les afficher)
  const f1Data = data.f1.map((value) => (value === 0 ? null : value));
  const f2Data = data.f2.map((value) => (value === 0 ? null : value));
  const f3Data = data.f3.map((value) => (value === 0 ? null : value));

  // Labels pour l'axe X
  const labels = [
    "00h",
    "01h",
    "02h",
    "03h",
    "04h",
    "05h",
    "06h",
    "07h",
    "08h",
    "09h",
    "10h",
    "11h",
    "12h",
    "13h",
    "14h",
    "15h",
    "16h",
    "17h",
    "18h",
    "19h",
    "20h",
    "21h",
    "22h",
    "23h",
  ];

  // Datasets - les 3 flux sont toujours présents
  const datasets = [];

  // Bolus - Barres (uniquement pour les patients non-LECIGIMON)
  if (!isLecigimon) {
    datasets.push({
      label: "Bolus",
      data: data.bolus,
      backgroundColor: "#7F7DE7",
      borderColor: "#7F7DE7",
      type: "bar",
      barThickness: 5,
      categoryPercentage: 1,
      barPercentage: 0.5,
      yAxisID: "y1",
      borderRadius: 4,
      datalabels: { display: false },
    });
  }

  // F1 - Ligne
  datasets.push({
    label: "F1",
    data: f1Data,
    backgroundColor: "#268A9A",
    borderColor: "#268A9A",
    type: "line",
    pointRadius: 0,
    fill: false,
    stepped: "before",
    yAxisID: "y",
    tension: 0,
    spanGaps: false,
    capBezierPoints: true,
  });
  // F2 - Ligne
  datasets.push({
    label: "F2",
    data: f2Data,
    backgroundColor: "#7FCAD6",
    borderColor: "#7FCAD6",
    type: "line",
    pointRadius: 0,
    fill: false,
    stepped: "before",
    yAxisID: "y",
    tension: 0,
    spanGaps: false,
    capBezierPoints: true,
  });
  // F3 - Ligne
  datasets.push({
    label: "F3",
    data: f3Data,
    backgroundColor: "#5FC9AB",
    borderColor: "#5FC9AB",
    type: "line",
    pointRadius: 0,
    fill: false,
    stepped: "before",
    yAxisID: "y",
    tension: 0,
    spanGaps: false,
    capBezierPoints: true,
  });

  return {
    labels: labels,
    datasets: datasets,
  };
};
